export default {
  'goldkid-advantage:title': 'Балаға арналған Kaspi Gold картасымен:',
  // 'goldkid-advantage:description': 'для получения пособий и соц.выплат',
  'goldkid-advantage:advantage-1': 'Балаңызға күнделікті жұмсайтын ақшасын аудара аласыз',
  'goldkid-advantage:img-alt-1': 'Балаңызға күнделікті жұмсайтын ақшасын аудара аласыз',
  'goldkid-advantage:advantage-2': 'Баланың ақша жұмсағанын қадағалай аласыз',
  'goldkid-advantage:img-alt-2': 'Баланың ақша жұмсағанын қадағалай аласыз',
  'goldkid-advantage:advantage-3': 'Баланың интернетте зат сатып алуына рұқсат беріп, тыйым сала аласыз',
  'goldkid-advantage:img-alt-3': 'Баланың интернетте зат сатып алуына рұқсат беріп, тыйым сала аласыз'
}
